"use client"

import {useEffect, useState} from 'react';
import {placeTypesRequest} from "@/utils/api/Place";
import {PlaceTypes} from "@/types/Places";

const usePlaceTypesData = () => {
  const [data, setData] = useState<PlaceTypes | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const fetched = await placeTypesRequest()
      if (fetched) {
        setData(fetched);
      }
    }
    if (!data) {
      fetchData();
    }
  }, [data]);

  return data;
};

export default usePlaceTypesData;
